import { debounce, throttle } from 'lodash';
// 防抖
export function debounceFn(fn, delay = 200, options = { leading: true, trailing: false }) {
  const debouncedFunc = debounce(fn, delay, options);  
  // 返回一个包装器函数，该函数接受额外的参数并调用debounced函数  
  return debouncedFunc;  
}

// 节流
export function throttleFn(fn, delay = 200, options = { leading: true, trailing: false }) {
  const throttleFunc = throttle(fn, delay, options);  
  // 返回一个包装器函数，该函数接受额外的参数并调用debounced函数  
  return throttleFunc;  
}

// 获取url的语言标识符
export function getLangFromUrl(){
  try {
    // 解析当前 URL
    let supportedLangs = ['en-us', 'id', 'zh-cn'], defaultLang = 'en-us';
    const currentUrl = new URL(window.location.href);
    const pathSegments = currentUrl.pathname.split('/').filter(segment => segment);
    // 获取第一个路径段（可能是语言代码）
    const firstSegment = pathSegments[0];
    
    // 检查是否是有效的语言代码
    if (firstSegment && supportedLangs.includes(firstSegment.toLowerCase())) {
      return firstSegment.toLowerCase();
    }
     // 没有匹配则返回默认语言
    return defaultLang;
  } catch (error) {
    console.error('提取语言代码失败:', error,defaultLang);
    return defaultLang;
  }
}

export const LOCALE_STORAGE_KEY = 'asogrow_locale'

export function normalizeLocale(locale) {
  if (locale === 'zh' || locale === 'zh-cn') return 'zh'
  if (locale === 'en' || locale === 'en-us') return 'en'
  return null
}

export function getStoredLocale() {
  try {
    return normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY))
  } catch (error) {
    return null
  }
}

let i18nInstance = null
let currentLocale = null

export function setI18nInstance(i18n) {
  i18nInstance = i18n
  if (i18n && i18n.locale) {
    currentLocale = normalizeLocale(i18n.locale) || currentLocale
  }
}

export function setStoredLocale(locale) {
  const normalized = normalizeLocale(locale)
  if (!normalized) return
  currentLocale = normalized
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, normalized)
  } catch (error) {
    console.error('保存语言偏好失败:', error)
  }
}

export function toAcceptLanguage(locale) {
  return normalizeLocale(locale) === 'zh' ? 'zh-cn' : 'en-us'
}

export function getAcceptLanguage() {
  if (i18nInstance && i18nInstance.locale) {
    return toAcceptLanguage(i18nInstance.locale)
  }
  const locale = currentLocale || getStoredLocale() || normalizeLocale(getLangFromUrlPath()) || 'en'
  return toAcceptLanguage(locale)
}

export function getLangFromUrlPath() {
  try {
    const supportedLangs = ['en-us', 'zh-cn']
    const pathSegments = window.location.pathname.split('/').filter(segment => segment)
    const firstSegment = pathSegments[0]
    if (firstSegment && supportedLangs.includes(firstSegment.toLowerCase())) {
      return firstSegment.toLowerCase()
    }
    return null
  } catch (error) {
    console.error('提取 URL 语言路径失败:', error)
    return null
  }
}

export function resolveInitialLocale() {
  const urlLang = getLangFromUrlPath()
  if (urlLang === 'zh-cn') {
    setStoredLocale('zh')
    return 'zh'
  }
  if (urlLang === 'en-us') {
    setStoredLocale('en')
    return 'en'
  }
  const storedLocale = getStoredLocale()
  if (storedLocale) {
    currentLocale = storedLocale
    return storedLocale
  }
  currentLocale = 'en'
  return 'en'
}

// export function createRequiredRule(vm, i18nKey, trigger = ['blur', 'change']) {
//   return {
//     required: true,
//     trigger,
//     validator: (rule, value, callback) => {
//       console.log('createRequiredRule vm',value,i18nKey,vm.$t(i18nKey));
//       if (!value) {
//         callback(new Error(vm.$t(i18nKey)))
//       } else {
//         callback()
//       }
//     }
//   }
// }